





















import React, { useState, useRef, useEffect } from "react";
import "./Payment.css";
import order from "./order-delivered.jpg";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from "axios";

const Paymentdata = ({ orderId: propOrderId }) => {
  const platformCharge = 1;
  const [showNewPage, setShowNewPage] = useState(false);
  const [orderData, setOrderData] = useState({});


  const discountAmount = orderData?.discountAmount ?? 0; // safe access & default



  const [loading, setLoading] = useState(false);


  const printRef = useRef(); // Reference for printable content
  const {
    subTotal = 0,
    serviceCharge = 0,
    platformCharges = 0,
    deliveryCharges = 0,
    packingCharges = 0,
    cgst = 0,
    sgst = 0,
    service = "",
  } = orderData || {};


  // Calculate grand total
  const grandTotal =
    subTotal +
    platformCharge +
    cgst +
    sgst -
    discountAmount;



  const orderId = propOrderId || localStorage.getItem("orderId");
  const screenWidth = window.innerWidth;

  const getTimeLabelWidth = () => {
    if (screenWidth >= 1000 && screenWidth <= 1200) {
      return "110px"; // between 1000px–1200px
    } else {
      return "150px"; // below 1000 or above 1200
    }
  };
  useEffect(() => {
    // console.log("🔁 useEffect running. Current orderId:", orderId);

    if (!orderId) {
      console.warn("⚠️ No orderId found, skipping fetch.");
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        // console.log("🌐 Fetching order details for:", orderId);

        // ✅ Get token from localStorage
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
          console.error("❌ No auth token found in localStorage");
          return;
        }

        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/order/${orderId}`,
          {
            headers: {
              "Authorization": `Bearer ${authToken}`, // ✅ send token
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          // console.log("✅ Order details fetched:", response.data);
          setOrderData(response.data);
        } else {
          console.error("⚠️ Unexpected response:", response);
        }
      } catch (error) {
        console.error("❌ Failed to fetch order details:", error.response?.data || error.message);
      }
    };

    fetchOrderDetails();
  }, [orderId]);


  const handlePrint = () => {
    if (!printRef.current) return;

    const originalContent = document.body.innerHTML;

    const fullClone = printRef.current.cloneNode(true);
    const minimalClone = printRef.current.cloneNode(true);

    // Remove buttons & banners
    [fullClone, minimalClone].forEach(clone => {
      clone.querySelectorAll(".buttons-data, .buttons-datas").forEach(btn => btn.remove());
      const banner = clone.querySelector(".paymentpage");
      if (banner) banner.remove();
    });

    // Style charges block in FULL receipt only
    [fullClone].forEach(clone => {
      clone.querySelectorAll(".charges-block").forEach(el => {
        el.style.fontSize = "9px";
        el.style.lineHeight = "1.1";
        el.style.margin = "0";
        el.style.padding = "0";
        el.style.textAlign = "center";
      });

      clone.querySelectorAll(".charges-block dl").forEach(dl => {
        dl.style.margin = "1px 0";
      });

      clone.querySelectorAll(".charges-block dt, .charges-block dd").forEach(el => {
        el.style.fontSize = "9px";
        el.style.fontWeight = "900";
      });
    });

    // Remove S.No column (index 0)
    [fullClone, minimalClone].forEach(clone => {
      clone.querySelectorAll("table").forEach(table => {
        table.querySelectorAll("tr").forEach(row => {
          const cells = row.querySelectorAll("td, th");
          if (cells[0]) cells[0].remove();
        });
      });
    });

    // Remove headers in minimalClone
    minimalClone.querySelectorAll(".order-time, .order-location").forEach(el => el.remove());

    // 🔥 Keep ONLY Item + Qty columns in minimalClone
    minimalClone.querySelectorAll("table").forEach(table => {
      const headerCells = table.querySelectorAll("th");
      let keepIndexes = [];

      headerCells.forEach((th, i) => {
        const txt = th.innerText.toLowerCase();
        if (txt.includes("item") || txt.includes("product") || txt.includes("name")) keepIndexes.push(i);
        if (txt.includes("qty") || txt.includes("quantity") || txt.includes("count")) keepIndexes.push(i);
      });

      table.querySelectorAll("tr").forEach(row => {
        const cells = row.querySelectorAll("td, th");
        cells.forEach((cell, i) => {
          if (!keepIndexes.includes(i)) cell.remove();
        });
      });
    });

    // Remove totals in minimalClone
    minimalClone.querySelectorAll(".totals-section, .grand-total, .total-amount, .price-summary").forEach(el => el.remove());

    // Remove extra elements
    [minimalClone, fullClone].forEach(clone => {
      const chargesBlock = clone.querySelector('div[style*="marginTop: 10px"]');
      if (chargesBlock) chargesBlock.remove();
      clone.querySelectorAll(".house, hr, .section-divider, .header-divider, .grand-divider, .thin-divider").forEach(el => el.remove());
    });

    // 🔥 FINAL FILTER — remove PRICE texts but KEEP quantity
    minimalClone.querySelectorAll("*").forEach(el => {
      const text = el.innerText?.trim();
      if (!text) return;

      const lower = text.toLowerCase();

      // Remove keywords like price, total, tax, gst
      if (
        lower.includes("₹") ||
        lower.includes("rs") ||
        lower.includes("rate") ||
        lower.includes("amount") ||
        lower.includes("total") ||
        lower.includes("gst") ||
        lower.includes("cgst") ||
        lower.includes("sgst") ||
        lower.includes("tax") ||
        lower.includes("grand")
      ) {
        el.remove();
        return;
      }

      // KEEP numeric values (quantity)
      if (/^[0-9.,/-]+$/.test(text)) {
        return; // do NOT remove — fixes qty missing
      }

      // Remove mixed price formats
      if (/₹\s*\d+|^\d+(\.\d+)?\s*\/?-?$/.test(text)) {
        el.remove();
        return;
      }
    });

    // Format date/time helpers
    const formatDate = dateStr => {
      const date = dateStr ? new Date(dateStr) : new Date();
      return date.toLocaleDateString("en-GB");
    };

    const formatTime = timeStr => {
      return timeStr
        ? new Date(`1970-01-01T${timeStr}`).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        })
        : "";
    };

    const wrapOrderDetails = orderData => `
    <div class="paymentdata-screensrw" style="display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;font-size:11px;font-weight:900;margin:6px 0;">
      <div style="display:flex;justify-content:center;gap:20px;width:100%;margin-bottom:2px;">
        <div>OrderID: ${orderData.orderId}</div>
        <div>Type: ${orderData.orderType}</div>
      </div>
      <div style="display:flex;justify-content:center;gap:20px;width:100%;">
        <div>Date: ${formatDate(orderData.date)}</div>
        <div>Time: ${formatTime(orderData.time)}</div>
      </div>
      <div style="display:flex;justify-content:center;gap:20px;width:100%;">
        <div>Payment: ${orderData.paymentMethod}</div>
      </div>
    </div>
  `;

    [minimalClone, fullClone].forEach(clone => {
      clone.querySelectorAll(".paymentdata-screensrw").forEach(el => {
        el.outerHTML = wrapOrderDetails(orderData);
      });
    });

    const addThinLineBelowGrandTotal = root => {
      const grandTotalEls = root.querySelectorAll(".grand-total-section, .grand-total, .total-amount, .price-summary");
      grandTotalEls.forEach(el => {
        if (!el.nextElementSibling || !el.nextElementSibling.classList?.contains("thin-grand-divider")) {
          const hrAbove = document.createElement("hr");
          hrAbove.className = "tax-grand-divider";
          hrAbove.style.border = "0";
          hrAbove.style.height = "1px";
          hrAbove.style.backgroundColor = "#000";
          hrAbove.style.margin = "0px 0";
          hrAbove.style.width = "100%";
          el.insertAdjacentElement("beforebegin", hrAbove);

          const hrBelow = document.createElement("hr");
          hrBelow.className = "thin-grand-divider";
          hrBelow.style.border = "0";
          hrBelow.style.height = "1px";
          hrBelow.style.backgroundColor = "#000";
          hrBelow.style.margin = "2px 0";
          hrBelow.style.width = "100%";
          el.insertAdjacentElement("afterend", hrBelow);

          const footerDiv = document.createElement("div");
          footerDiv.style.fontSize = "10px";
          footerDiv.style.fontWeight = "900";
          footerDiv.style.textAlign = "center";
          footerDiv.style.marginTop = "-12px";
          footerDiv.style.marginBottom = "-2px";
          footerDiv.innerHTML = `
          <div style="margin-bottom: 4px;">FSSAI No: ${orderData.vendorFssai}</div>
          <div style="font-size: 11px; margin-bottom: 2px;">Thank you, visit again</div>
        `;
          hrBelow.insertAdjacentElement("afterend", footerDiv);
        }
      });
    };

    addThinLineBelowGrandTotal(fullClone);
    addThinLineBelowGrandTotal(minimalClone);

    const wrapSection = (clone, showGSTIN = false) => {
      let extraInfoHTML = "";
      if (showGSTIN) {
        extraInfoHTML = `
        <div style="font-size:12px;font-weight:900;margin:2px 0;">GSTIN:${orderData.vendorGstIn}</div>
      `;
      }

      return `
      <div style="text-align:center;margin-bottom:4px;">
        <h5 style="font-size:16px;text-transform:uppercase;font-weight:900;margin:0;padding:0;">
          ${bannerData?.companyName || "MAAMAAS HOUSE"}
        </h5>
        ${extraInfoHTML}
        <div style="width:100%;border-top:3px solid black;margin:4px 0;"></div>
      </div>
      <div>${clone.innerHTML}</div>
    `;
    };

    const combinedReceipt = `
    <div style="margin-bottom:20px;">
      ${wrapSection(minimalClone)}
    </div>
    <div style="page-break-before: always;"></div>
    <div style="margin-top:20px;">
      ${wrapSection(fullClone, true)}
    </div>
  `;

    const styledContent = `
<html>
<head>
<title>Receipt</title>
<style>
@media print {
  @page { size: 80mm auto; margin: 0; }
  body { color:black !important; font-family:monospace; background:white !important; width:80mm; margin:0 auto; padding:2px; font-weight:900 !important; }
  h3,h5,p,dt,dd,span,div { color:black !important; font-weight:900 !important; text-align:center; }
  table { width:100%; border-collapse:collapse; table-layout:fixed; color:black !important; font-size:9px !important; border-top:3px solid black !important; border-bottom:3px solid black !important; }
  th, td { text-align:center !important; vertical-align:middle; padding:3px 2px !important; font-weight:900 !important; border-bottom:2px solid black !important; }
  hr { border:0; height:1px; background-color:#000; margin:4px 0; width:100%; }
}
</style>
</head>
<body>${combinedReceipt}</body>
</html>
`;

    const printOnce = (html, printWindow) => {
      const doc = printWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
      printWindow.focus();
      printWindow.print();
    };

    const printWindow = window.open("", "", "width=600,height=800");
    if (!printWindow) {
      alert("Please allow pop-ups for this site to print receipts.");
      return;
    }

    printOnce(styledContent, printWindow);
    setTimeout(() => {
      printOnce(styledContent, printWindow);

      setTimeout(() => {
        printWindow.close();

        // 🔥🔥🔥 FINAL REDIRECT AFTER PRINT 🔥🔥🔥
        window.location.href = "/homepage";

      }, 800);
    }, 2000);

    document.body.innerHTML = originalContent;
  };





  const handleDownload = async () => {
    const receipt = document.querySelector(".three");
    const buttons = receipt.querySelectorAll(".buttons-data");

    // ✅ Hide buttons before capture
    buttons.forEach(btn => (btn.style.display = "none"));

    // 🕐 Wait for browser to re-render before capturing
    await new Promise(resolve => setTimeout(resolve, 100));

    // Temporarily adjust height
    const originalStyle = {
      height: receipt.style.height,
      overflowY: receipt.style.overflowY
    };
    receipt.style.height = "auto";
    receipt.style.overflowY = "visible";

    html2canvas(receipt, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
      pdf.save("Payment_Receipt.pdf");

      // ✅ Restore buttons and styles after saving
      buttons.forEach(btn => (btn.style.display = ""));
      receipt.style.height = originalStyle.height;
      receipt.style.overflowY = originalStyle.overflowY;
    }).catch((err) => {
      console.error("❌ Error generating PDF:", err);
      buttons.forEach(btn => (btn.style.display = ""));
    });
  };


  const [bannerData, setBannerData] = useState(null);

  const [error, setError] = useState("");

  const vendorId = localStorage.getItem("vendorId");

  useEffect(() => {
    if (!vendorId) return;

    const source = axios.CancelToken.source();

    (async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("authToken"); // ✅ get token from localStorage

        const { data } = await axios.get(
          `https://backend.maamaas.com/food/api/banner/vendor/${vendorId}`,
          {
            cancelToken: source.token,
            headers: {
              Authorization: `Bearer ${token}` // ✅ pass token in header
            }
          }
        );

        // Massage the fields once
        setBannerData({
          ...data,
          companyName: data.companyName || "No Name",
        });
        setError("");
      } catch (err) {
        if (!axios.isCancel(err)) {
          // console.error(err);
          setError("Could not load banner details.");
        }
      } finally {
        setLoading(false);
      }
    })();

    return () => source.cancel();
  }, [vendorId]);




  return (
    <>
      <div
        className="paymentdata-screen"
        style={{
          marginTop: "-40px",
          marginLeft: "0px",
          overflow: "hidden",       // IMPORTANT → hide scrollbar area
          height: "515px",
          borderRadius: "10px",
          background: "rgb(177, 93, 198)"
        }}
      >
        {/* Inner scrolling wrapper */}
        <div
          ref={printRef}
          style={{
            height: "100%",
            overflowY: "scroll",
            overflowX: "scroll",
            marginRight: "-20px",   // hides scrollbar in Vivaldi & all others
            paddingRight: "20px",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none" // IE/Edge
          }}
        >
          <div className="paymentpage">
            <img src={order} alt="image1" style={{ height: "50px", borderRadius: "50%", marginLeft: "0px", marginTop: "20px" }} />
            <h3 style={{ color: "#fff", marginTop: "30px", marginLeft: "20px" }}>Payment successful!!!</h3>
          </div>
          <hr style={{ border: "1px solid black", }} />
          <h5 className="house"> {bannerData?.companyName || "MAAMAAS HOUSE"}</h5>
          <div className="four row paymentdata-screensrw" style={{ marginLeft: "9px", marginTop: "20px" }}>
            <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1 order-id">
              <dt style={{ minWidth: "150px" }}>Order ID</dt>
              <dd style={{ minWidth: "30px" }}>:</dd>
              <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>{orderData.orderId}</dd>
            </div>
            <div style={{ color: "#fff", fontSize: "18px", }} className="col-lg-6 p list1">
              <dt style={{ minWidth: getTimeLabelWidth() }}>Date</dt>
              <dd style={{ minWidth: "30px" }}>:</dd>
              <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
                {orderData.date ? new Date().toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB')}
              </dd>

            </div>

            <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
              <dt style={{ minWidth: "150px" }}>Order Type</dt>
              <dd style={{ minWidth: "30px" }}>:</dd>
              <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
                {orderData.orderType}
              </dd>
            </div>

            <div style={{ color: "#fff", fontSize: "18px" }} className="col-lg-6 p list1">
              <dt style={{ minWidth: getTimeLabelWidth() }}>Time</dt>
              <dd style={{ minWidth: "30px" }}>:</dd>
              <dd style={{ minWidth: "100px", color: '#000', fontWeight: "bold" }}>
                {orderData.time ? new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}
              </dd>
            </div>





          </div>
          <hr style={{ border: "1px solid black", }} />
          {loading ? (
            <p>Loading...</p>
          ) : Array.isArray(orderData.order) && orderData.order.length > 0 ? (
            <>
              <table
                className="order-table order-table items-table"
                style={{ marginLeft: "10px", fontSize: "20px", fontWeight: "bold" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {orderData.order.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.dishName || item.order?.dishName || "N/A"}</td>
                      <td>{item.quantity ?? "N/A"}</td>
                      <td>{item.price ? item.price.toFixed(2) : "0.00"}</td>
                      <td>
                        {item.price && item.quantity
                          ? (item.price * item.quantity).toFixed(2)
                          : "0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <hr style={{ border: "1px dashed black", }} />
              {/* Totals Section */}
              <div className="charges-block" style={{ marginTop: "5px" }}>
                <dl style={{ display: "flex", justifyContent: "end", marginRight: "30px", fontSize: "15px", marginBottom: "2px" }}>
                  <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>Sub Total</dt>
                  <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{orderData?.subTotal ?? "0.00"}</dt>
                </dl>

                <dl style={{ display: "flex", justifyContent: "end", marginRight: "30px", fontSize: "15px", marginBottom: "2px" }}>
                  <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>Platform Charges</dt>
                  <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{platformCharges ?? "0.00"}</dt>
                </dl>

                <dl style={{ display: "flex", justifyContent: "end", marginRight: "30px", fontSize: "15px", marginBottom: "2px" }}>
                  <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>Service Charges</dt>
                  <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{serviceCharge ?? "0.00"}</dt>
                </dl>

                <dl style={{ display: "flex", justifyContent: "end", marginRight: "30px", fontSize: "15px", marginBottom: "2px" }}>
                  <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>CGST</dt>
                  <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{cgst ?? "0.00"}</dt>
                </dl>

                <dl style={{ display: "flex", justifyContent: "end", marginRight: "30px", fontSize: "15px", marginBottom: "2px" }}>
                  <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>SGST</dt>
                  <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{sgst ?? "0.00"}</dt>
                </dl>
              </div>

              <hr style={{ border: "1px dashed black", }} />
              <div className="grand-total-section">
                <dl
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginRight: "30px",
                    fontSize: "15px",
                  }}
                >
                  <dt style={{ minWidth: "200px", color: "#fff", fontSize: "23px" }}>
                    Grand Total
                  </dt>
                  <dt style={{ minWidth: "60px", fontSize: "23px" }}>
                    ₹{orderData?.grandTotal ?? "0.00"}
                  </dt>
                </dl>
              </div>

            </>
          ) : (
            <p>No order data available.</p>
          )}


          <div>

            <div className="thankyou">

              <h5 style={{ color: "#fff", fontWeight: "bold", fontSize: "24px" }} className="buttons-datas">Thank You!!! Visit Again.....</h5>
              <p style={{ color: "#ddd", fontSize: "18px", marginTop: "0px" }}>www.maamaas.com</p>
              <div className="buttons-data" style={{ display: window.innerWidth <= 768 ? 'none' : 'block' }}>
                <button className="pdfbutton" onClick={handlePrint}>Print</button>
                <button className="pdfbutton" onClick={handleDownload}>⬇️Download</button>
              </div>
            </div>


          </div>
        </div>


      </div>

      <style>{`
      @media (max-width : 990px) &&( min-width : 1024px){
      .three{
      width:560px;
      }
      
      }
      /* Extra small devices (phones, 600px and down) */
@media (max-width: 600px) { }

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) { }

/* Medium devices (landscape tablets, 768px and up) */
@media (min-width: 768px) { }

/* Large devices (laptops/desktops, 992px and up) */
@media (min-width: 992px) { }

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media (min-width: 1200px) { }

/* Custom breakpoints for specific ranges */
@media (min-width: 768px) and (max-width: 991px) { } /* Tablet range */
@media (min-width: 992px) and (max-width: 1199px) { } /* Small desktop range */
@media (min-width: 1200px) and (max-width: 1399px) { 
} /* Medium desktop range */
/* Mobile-first approach (most common) */
@media (min-width: 640px) { }   /* sm */
@media (min-width: 768px) { }   /* md */
@media (min-width: 1024px) { }  /* lg */
@media (min-width: 1280px) { }  /* xl */
@media (min-width: 1536px) { }  /* 2xl */

/* Height-based media queries */
@media (max-height: 600px) { }  /* Short screens */
@media (min-height: 800px) { }  /* Tall screens */

/* Orientation */
@media (orientation: portrait) { }
@media (orientation: landscape) { }

/* High-resolution displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) { }
      
      `}
      </style>

    </>
  );
};


export default Paymentdata;
